import LottieViewer from '@/components/lottie-viewer';
import { cn } from '@/utils/cn';
import discount from '@/assets/lottie-files/discount.lottie';
import fire from '@/assets/lottie-files/fire.lottie';
import medal from '@/assets/lottie-files/medal.lottie';
interface Props {
  title: string;
}
const CustomAnimatedTitle = ({
  title
}: Props) => {
  const isFireIcon = title === 'آفرهای ویژه';
  const titleIcon = (title: string) => {
    switch (title) {
      case 'بیشترین تخفیف‌ها در یک نگاه':
      case 'جذاب‌ترین‌ها':
        return discount;
      case 'آفرهای ویژه':
        return fire;
      case 'ترین‌های خانومی':
        return medal;
      default:
        return '';
    }
  };
  if (titleIcon(title) === '') return null;
  return <div className='mb-3 flex w-full items-center justify-center lg:mb-5 lg:gap-2' data-sentry-component="CustomAnimatedTitle" data-sentry-source-file="custom-animated-title.tsx">
            <LottieViewer src={titleIcon(title)} className={cn('h-8 w-8', isFireIcon && 'h-7 w-7 lg:h-8 lg:w-8')} width={32} height={32} data-sentry-element="LottieViewer" data-sentry-source-file="custom-animated-title.tsx" />
            <span className='text-base font-bold lg:text-lg'>{title}</span>
        </div>;
};
export default CustomAnimatedTitle;